module.exports = __webpack_public_path__ + "img/17.e84c6af7.png";